// src/app/currency-table/currency-table.component.ts
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
 import { Currency } from 'src/app/shared/models/currency';
import { CurrencyService } from './currency.service';

@Component({
  selector: 'app-currency-table',
  templateUrl: './currency-table.component.html',
  styleUrls: ['./currency-table.component.scss']
})
export class CurrencyTableComponent implements OnInit,OnChanges {
  

  // currencies = [
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},
  //   { country: "1", flagUrl: 'assets/images/Frame (2).png', sellingPrice: 49, buyingPrice: 30,index:'assets/images/trend-up.png'},

  // ];

  currencies:any =[];

  @Input() data: Array<{symbol:string,value:string}> = [];

  paginatedData: Array<{symbol:string,value:string}> = [];

  itemsPerPage = 10;
  currentPage = 1;
  totalPages = 0;
  pages: number[] = [];

  constructor(private currencyService: CurrencyService) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.totalPages = Math.ceil(this.data.length / this.itemsPerPage);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    this.updatePaginatedData();
  }

  ngOnInit(): void {
    // [key, res['conversion_rates'][key]]
    // this.currencyService.getCurrencies("egp").subscribe((res:any)=>{
    //   if(res.result){
      // this.data =  Object.keys(res['conversion_rates']).map((key) =>{
      //   return{
      //     symbol:key,
      //     value:res['conversion_rates'][key]
      //   }
      // }); 

    //     this.totalPages = Math.ceil(this.data.length / this.itemsPerPage);
    //     this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    //     this.updatePaginatedData();

    //   }
      
    // });

   
    
   
   
  }

  updatePaginatedData() {
    
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    
    this.paginatedData = this.data.slice(startIndex, startIndex + this.itemsPerPage);
    // console.log('jaserdata',this.paginatedData)
  }

  setPage(page: number) {
    this.currentPage = page;
    this.updatePaginatedData();
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }
}
